
import classes from "./noDataBlock.scss";
import ReactHtmlParser from 'react-html-parser';
import CustomAnchorTag from "../CommonComponents/CustomAnchorTag/customAnchorTag";
import SearchInfoPopUp from "../../Dashboard/Common/searchInfoPopup";
class NoDataBlock extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchInfoPopUp: false,
            saAndCaContent: props.isCA && props.isSA,
            caContent:props.isCA,
            saContent:props.isSA
        };
    }
    searchErrorContent = (noDataSecli, noDataSecliCA, noDataSecliSA) => {
        let isCa = this.props.isCA, isSa = this.props.isSA;
        if (isCa && isSa) {
            return noDataSecli;
        } else if (isSa) {
            return noDataSecliSA;
        } else if (isCa) {
            return noDataSecliCA;
        }
    }
    removeTag = (initialText) => {
        const regex=/<\s*span\b[^>]*>(.*?)<\s*\/\s*span\s*>/g;
        let matches=[];
        let match;
    
        while ((match=regex.exec(initialText))!==null){
          matches.push(match[1]);
        }
        return matches[0];
    }
    dssSearchRgx = () => {
        let noDataTitleRgx = new RegExp('<span id="searchbox_noDataTitle">([^]*?)</span>', 'g');
        let noDataFirstliRgx = new RegExp('<span id="searchbox_noDataFirstli">([^]*?)</span>', 'g');
        let noDataSecliRgx = new RegExp('<span id="searchbox_noDataSecli">([^]*?)</span>', 'g');
        let noDataSecliCASARgx= new RegExp('<span id="searchbox_noDataSecliCASA">([^]*?)</span>', 'g');
        let noDataSecliCARgx = new RegExp('<span id="searchbox_noDataSecliCA">([^]*?)</span>', 'g');
        let noDataSecliSARgx = new RegExp('<span id="searchbox_noDataSecliSA">([^]*?)</span>', 'g');
        let noDataSeeBillRgx = new RegExp('<span id="searchbox_seebillsamp">([^]*?)</span>', 'g');
        let noDataAccNumRgx = new RegExp('<span id="searchbox_noDataAccNum">([^]*?)</span>', 'g');
        if (!_.isEmpty(this.props.content)) {
            let noDataTitle = this.props.content.dss_search_nodata.body.match(noDataTitleRgx);
            let noDataFirstli = this.props.content.dss_search_nodata.body.match(noDataFirstliRgx);
            let noDataSecli = this.props.content.dss_search_nodata.body.match(noDataSecliRgx);
            let noDataSecliCASA = this.props.content.dss_search_nodata.body.match(noDataSecliCASARgx);
            let noDataSecliCA = this.props.content.dss_search_nodata.body.match(noDataSecliCARgx);
            let noDataSecliSA = this.props.content.dss_search_nodata.body.match(noDataSecliSARgx);
            let noDataSeeBill = this.props.content.dss_search_nodata.body.match(noDataSeeBillRgx);
            let noDataAccNum = this.props.content.dss_search_nodata.body.match(noDataAccNumRgx);
            return {
                noData: {
                    noDataTitle: noDataTitle ? ReactHtmlParser(noDataTitle) : "",
                    noDataFirstli: noDataTitle ? ReactHtmlParser(noDataFirstli) : "",
                    noDataSecli: noDataTitle ? ReactHtmlParser(this.searchErrorContent(noDataSecli, noDataSecliCA, noDataSecliSA)) : "",
                    noDataSecliCASA: noDataTitle ? ReactHtmlParser(noDataSecliCASA) : "",
                    noDataSeeBill: noDataTitle ? this.removeTag(noDataSeeBill[0]) : "",
                    noDataAccNum: noDataTitle ? ReactHtmlParser(noDataAccNum) : "",
                }
            };
        } else {
            return {
                noData: {
                    noDataTitle: "",
                    noDataFirstli: "",
                    noDataSecli: "",
                    noDataSecliCASA:"",
                    noDataSeeBill:"",
                    noDataAccNum: ""
                }
            };
        }
    }
    handleSearchInfo = () => {
        this.setState({ searchInfoPopUp: !this.state.searchInfoPopUp });
    }
    render() {
        let { noData } = this.dssSearchRgx();
        let searchInfoPopUp = this.state.searchInfoPopUp ? <SearchInfoPopUp saAndCaContent={this.state.saAndCaContent} caContent={this.state.caContent} saContent={this.state.saContent} handleSearchInfo={this.handleSearchInfo} content={this.props.content} /> : null;
        return (
            <div className={[classes.sceNoDataSec, this.props.isSearchTextError?classes.sceSearchErrorSpace:null].join(" ")}>
                {searchInfoPopUp}
                <div className={classes.sceNoDataTitle}>{noData.noDataTitle}</div>
                <ul>
                    <li>{noData.noDataFirstli}</li>
                    <li className={classes.sceListItem}>{noData.noDataSecli}{ }{this.state.saAndCaContent ?null:<CustomAnchorTag linkName={noData.noDataSeeBill} onClick={this.handleSearchInfo} isUnderline />}{ }{noData.noDataAccNum}</li>
                    {this.state.saAndCaContent ? <li className={classes.sceListItem}>{noData.noDataSecliCASA}{" "}<CustomAnchorTag linkName={noData.noDataSeeBill} onClick={this.handleSearchInfo} isUnderline /></li> : null}
                    
                </ul>
            </div>
        );
    }
}
export default NoDataBlock;
